import { QRCode } from 'react-qrcode-logo';


const AppQrCode = ({value}:{value:string}) => {
    return <>
    <QRCode eyeRadius={[30,30,30,30]} size={100} logoImage='images/logo-white.png' logoWidth={30} logoHeight={30}  fgColor='#e33621' bgColor='#fff' value={`${value}`} />
    </>
}

export default AppQrCode